export default {
  from: 'から',
  perLesson: '/レッスン',
}
